export enum LanguageEnum {
  English = 'en',
  Arabic = 'ar',
  Urdu = 'ur'
}
